import { range } from 'wanderu-utils';

import {
    COLUMN_SCALING_FACTOR,
    GRAPH_OFFSET,
    MAX_COLUMN_WIDTH,
    SMOOTHING_FACTOR,
    VERTICAL_OFFSET,
} from './constants';

function _getOpposedLine(pointA, pointB) {
    const lengthX = pointB.xCoord - pointA.xCoord;
    const lengthY = pointB.yCoord - pointA.yCoord;

    return {
        length: Math.sqrt(lengthX ** 2 + lengthY ** 2),
        angle: Math.atan2(lengthY, lengthX),
    };
}

function _getControlPoints(current, previous, next, reverse) {
    const opposedLine = _getOpposedLine(previous || current, next || current);

    const angle = opposedLine.angle + (reverse
        ? Math.PI
        : 0);
    const length = opposedLine.length * SMOOTHING_FACTOR;

    const x = current.xCoord + Math.cos(angle) * length;
    const y = current.yCoord + Math.sin(angle) * length;
    return [x, y];
}

function drawCurve(point, index, arr) {
    const controlPointStart = _getControlPoints(arr[index - 1], arr[index - 2], point);
    const controlPointEnd = _getControlPoints(point, arr[index - 1], arr[index + 1], true);

    const { xCoord: x, yCoord: y } = point;
    const [startX, startY] = controlPointStart;
    const [endX, endY] = controlPointEnd;
    return `C ${startX},${startY} ${endX},${endY} ${x},${y}`;
}

function drawLine(point) {
    const { xCoord: x, yCoord: y } = point;
    return `L ${x} ${y}`;
}

function calculateChartData(chartOpts) {
    const {
        data,
        containerWidth,
        containerHeight,
        numVerticalTicks,
        roundingFactor,
    } = chartOpts;

    const maxValueX = data.length;
    const maxValueY = Math.max(...data.map((d) => d.y));
    const roundedMaxY = Math.ceil(maxValueY / roundingFactor) * roundingFactor;
    const scalingFactorX = (containerWidth - GRAPH_OFFSET) / maxValueX;

    const incrementValue = Math.ceil(roundedMaxY / numVerticalTicks / roundingFactor)
        * roundingFactor;

    const verticalAxisLabels = range(numVerticalTicks + 1).map((num) => {
        return num * incrementValue;
    }).reverse();

    const maxVerticalY = Math.max(...verticalAxisLabels);
    const scalingFactorY = containerHeight / maxVerticalY;

    const dataPoints = data.reduce((coordinates, obj, index) => {
        const scaledX = index * scalingFactorX;
        const scaledY = obj.y * scalingFactorY;

        const xCoord = scaledX + GRAPH_OFFSET * COLUMN_SCALING_FACTOR;
        const yCoord = containerHeight - scaledY + VERTICAL_OFFSET;

        return {
            ...coordinates,
            [obj.x]: {
                xCoord,
                yCoord,
                xVal: obj.x,
                yVal: obj.y,
            },
        };
    }, {});

    const columnWidth = scalingFactorX > MAX_COLUMN_WIDTH
        ? MAX_COLUMN_WIDTH
        : scalingFactorX * COLUMN_SCALING_FACTOR;

    return {
        columnWidth,
        dataPoints,
        scalingFactorX,
        scalingFactorY,
        verticalAxisLabels,
    };
}

export {
    calculateChartData,
    drawCurve,
    drawLine,
};
